import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import {
	Button,
	Form,
	Input,
	Divider,
	Message
} from 'semantic-ui-react';

// Generic Components
import Alert from '../../components/alert';
import Loading from '../../components/loading';
import Tab from '../../components/tab';

// Specific Components
import PreviewEmail from './components/preview-email';

import Validator from '../../helpers/validator';
import GA from '../../helpers/ga';

import {
	renderAbandonedCartEmailTemplate,
	getAbandonedCartTemplateConnection,
	updateTemplateConnectionById,
	updateSampleEmailRecipientEmail,

	resetAlertMessage,
	reset,

	updateFormField
} from './actions';

const DEFAULT_STATE = {
	errorSettingsEmailSubject: false,
	errorSettingsTextEmailTitle: false,
	errorSettingsTextEmailSubtitle: false,
	errorSettingsTextEmailFooter: false,
	errorSettingsTextUnsubscribe: false,

	errorSettingsTextColorPrimary: false,
	errorSettingsSecondaryTextColor: false,
	errorSettingsButtonTextColor: false,
	errorSettingsColorButton: false,
	errorSettingsColorBackground: false,
	errorSettingsColorContainerBorder: false,
	errorSettingsColorContainerBackground: false,

	buttonUpdateLoading: false
};

const PAGE_VIEW_NAME = '/dashboard/emails/settings/customization/1';

export class TemplateSettingsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = DEFAULT_STATE;
		this.props.getAbandonedCartTemplateConnection();
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillUnmount() {
		this.props.reset();
	}

	componentWillUpdate (nextProps, nextState) {
		if (this.refs.alert && nextProps.meta && _.get(nextProps, 'meta.message')) {
			this.refs.alert.show(nextProps.meta);
			this.props.resetAlertMessage();
			this.setState({
				buttonUpdateLoading: false
			});
			return;
		}
	}

	componentWillReceiveProps (nextProps) {
		if (!nextProps.templateConnection) {
			nextProps.getAbandonedCartTemplateConnection();
			return;
		}

		if (nextProps.isHtmlUpdated) {
			return;
		}

		const settings = {
			// v1 fields
			color_button: _.get(nextProps.templateConnection, 'settings.color_button', '000000'),

			// v2 fields
			text_email_title: _.get(nextProps.templateConnection, 'settings.text_email_title', '[FIRST_NAME], you left some items in your cart'),
			text_email_subtitle: _.get(nextProps.templateConnection, 'settings.text_email_subtitle', 'Still want them? Get them before they\'re gone.'),
			text_email_footer: _.get(nextProps.templateConnection, 'settings.text_email_footer', 'Need help? Contact us anytime.'),
			text_unsubscribe: _.get(nextProps.templateConnection, 'settings.text_unsubscribe', 'If you\'d rather not receive future emails from us, unsubscribe here.'),
			text_product_quantity:_.get(nextProps.templateConnection, 'settings.text_product_quantity', 'Quantity'),
			text_product_price: _.get(nextProps.templateConnection, 'settings.text_product_price', 'Price'),
			text_button: _.get(nextProps.templateConnection, 'settings.text_button', 'Checkout'),

			text_color_primary: _.get(nextProps.templateConnection, 'settings.text_color_primary', '4E4E4E'),
			text_color_secondary: _.get(nextProps.templateConnection, 'settings.text_color_secondary', '4E4E4E'),
			text_color_button: _.get(nextProps.templateConnection, 'settings.text_color_button', 'FFFFFF'),

			color_background: _.get(nextProps.templateConnection, 'settings.color_background', 'FFFFFF'),
			color_container_border: _.get(nextProps.templateConnection, 'settings.color_container_border', 'FFFFFF'),
			color_container_background: _.get(nextProps.templateConnection, 'settings.color_container_background', 'FFFFFF'),

			first_name: 'John',
			last_name: 'Doe',
			products: [{
				product_name: 'Sample Product 1',
				product_price: 'HK$ 9.99',
				product_quantity: 1,
				product_image_url: 'https://assets.chated.io/images/abandoned-cart/sample-product-1.jpg'
			}, {
				product_name: 'Sample Product 2',
				product_price: 'HK$ 19.99',
				product_quantity: 2,
				product_image_url: 'https://assets.chated.io/images/abandoned-cart/sample-product-1.jpg'
			}]
		};

		this.props.renderAbandonedCartEmailTemplate(settings);
	}

	onSubmit = (e) => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'UpdateButton', 1);
		const templateConnection = this.props.templateConnection;

		// Validation
		const errorSettingsEmailSubject = Validator.required(this, templateConnection, 'settings.email_subject', 'errorSettingsEmailSubject');
		const errorSettingsTextEmailTitle = Validator.required(this, templateConnection, 'settings.text_email_title', 'errorSettingsTextEmailTitle');
		const errorSettingsTextEmailSubtitle = Validator.required(this, templateConnection, 'settings.text_email_subtitle', 'errorSettingsTextEmailSubtitle');
		const errorSettingsTextEmailFooter = Validator.required(this, templateConnection, 'settings.text_email_footer', 'errorSettingsTextEmailFooter');
		const errorSettingsTextUnsubscribe = Validator.required(this, templateConnection, 'settings.text_unsubscribe', 'errorSettingsTextUnsubscribe');
		const errorSettingsColorButton = Validator.colorRequired(this, templateConnection, 'settings.color_button', 'errorSettingsColorButton');
		const errorSettingsTextColorPrimary = Validator.colorRequired(this, templateConnection, 'settings.text_color_primary', 'errorSettingsTextColorPrimary');
		const errorSettingsTextColorSecondary = Validator.colorRequired(this, templateConnection, 'settings.text_color_secondary', 'errorSettingsTextColorSecondary');
		const errorSettingsTextColorButton = Validator.colorRequired(this, templateConnection, 'settings.text_color_button', 'errorSettingsTextColorButton');
		const errorSettingsColorBackground = Validator.colorRequired(this, templateConnection, 'settings.color_background', 'errorSettingsColorBackground');
		const errorSettingsColorContainerBorder = Validator.colorRequired(this, templateConnection, 'settings.color_container_border', 'errorSettingsColorContainerBorder');
		const errorSettingsColorContainerBackground = Validator.colorRequired(this, templateConnection, 'settings.color_container_background', 'errorSettingsColorContainerBackground');

		if (
			errorSettingsEmailSubject ||
			errorSettingsTextEmailTitle ||
			errorSettingsTextEmailSubtitle ||
			errorSettingsTextEmailFooter ||
			errorSettingsTextUnsubscribe ||
			errorSettingsColorButton ||
			errorSettingsTextColorPrimary ||
			errorSettingsTextColorSecondary ||
			errorSettingsTextColorButton ||
			errorSettingsColorBackground ||
			errorSettingsColorContainerBorder ||
			errorSettingsColorContainerBackground
		) {
			console.log('errorSettingsEmailSubject = ', errorSettingsEmailSubject);
			console.log('errorSettingsTextEmailTitle = ', errorSettingsTextEmailTitle);
			console.log('errorSettingsTextEmailSubtitle = ', errorSettingsTextEmailSubtitle);
			console.log('errorSettingsTextEmailFooter = ', errorSettingsTextEmailFooter);
			console.log('errorSettingsTextUnsubscribe = ', errorSettingsTextUnsubscribe);
			console.log('errorSettingsColorButton = ', errorSettingsColorButton);
			console.log('errorSettingsTextColorPrimary = ', errorSettingsTextColorPrimary);
			console.log('errorSettingsTextColorSecondary = ', errorSettingsTextColorSecondary);
			console.log('errorSettingsTextColorButton = ', errorSettingsTextColorButton);
			console.log('errorSettingsColorBackground = ', errorSettingsColorBackground);
			console.log('errorSettingsColorContainerBorder = ', errorSettingsColorContainerBorder);
			console.log('errorSettingsColorContainerBackground = ', errorSettingsColorContainerBackground);
			return;
		}

		this.setState({
			buttonUpdateLoading: true
		});

		// Save Template Connection
		this.props.updateTemplateConnectionById(templateConnection._id, templateConnection);
	}

	onClickPreviewEmailButton = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'PreviewEmailButton', 1);
		this.refs.previewEmailModal.openModal();
	}

	onChangeField = (e, obj) => {
		if (obj.type === 'checkbox') {
			this.props.updateFormField(this.props.templateConnection, obj.name, obj.checked);
			return;
		}
		this.props.updateFormField(this.props.templateConnection, obj.name, obj.value);
	}

	render() {
		if (!this.props.templateConnection) {
			return <Loading />;
		}

		const paneHeight = this.props.containerHeight - 70; // 70px is size of first row;
		const templateConnection = this.props.templateConnection;
		const formGroupStyle = {marginTop: '20px'};
		const formFieldStyle = {paddingTop: '8px'};

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='First Email Settings'
				subHeaderText='Configure settings of the first abandoned cart email that will be sent to your customers'
			>
				<Alert ref='alert'/>
				<Form>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Subject'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom subject of abandoned cart emails'
							name='settings.email_subject'
							value={ _.get(templateConnection, 'settings.email_subject', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsEmailSubject }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Title'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom title of abandoned cart emails.'
							name='settings.text_email_title'
							value={ _.get(templateConnection, 'settings.text_email_title', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextEmailTitle }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Subtitle'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom subtitle of abandoned cart emails'
							name='settings.text_email_subtitle'
							value={ _.get(templateConnection, 'settings.text_email_subtitle', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextEmailSubtitle }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Footer'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom footer of abandoned cart emails'
							name='settings.text_email_footer'
							value={ _.get(templateConnection, 'settings.text_email_footer', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextEmailFooter }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Unsubscribe'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom unsubscribe text of abandoned cart emails'
							name='settings.text_unsubscribe'
							value={ _.get(templateConnection, 'settings.text_unsubscribe', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextUnsubscribe }
						/>
					</Form.Group>
					<Form.Group
					>
						<Form.Field width='4' />
						<Message info style={{marginTop: '0px'}}>
							<p>Use your clients' names in the email by adding [FIRST_NAME] and/or [LAST_NAME].</p>
							<p>We will replace it with their name when we send the email. Try it out! Sample client: John Doe</p>
						</Message>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Product Quantity Text'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Text to replace the "quantity" english word'
							name='settings.text_product_quantity'
							value={ _.get(templateConnection, 'settings.text_product_quantity', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextProductQuantity }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Product Price Text'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Text to replace the "price" english word'
							name='settings.text_product_price'
							value={ _.get(templateConnection, 'settings.text_product_price', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextProductPrice }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Button Text'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Text to replace the "Checkout" word'
							name='settings.text_button'
							value={ _.get(templateConnection, 'settings.text_button', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextButton }
						/>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Title and Product Name Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.text_color_primary'
							value={ _.get(templateConnection, 'settings.text_color_primary', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextColorPrimary }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.text_color_primary', '4E4E4E')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Subtitle and Product Details Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.text_color_secondary'
							value={ _.get(templateConnection, 'settings.text_color_secondary', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextColorSecondary }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.text_color_secondary', '')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Button Text Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.text_color_button'
							value={ _.get(templateConnection, 'settings.text_color_button', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsTextColorButton }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.text_color_button', '')}`}}
						/>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Button Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_button'
							value={ _.get(templateConnection, 'settings.color_button', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorButton }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_button', '000000')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Background Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_background'
							value={ _.get(templateConnection, 'settings.color_background', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorBackground }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_background', 'FFFFFF')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Container Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_container_background'
							value={ _.get(templateConnection, 'settings.color_container_background', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorContainerBackground }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_container_background', 'FFFFFF')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Border Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_container_border'
							value={ _.get(templateConnection, 'settings.color_container_border', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorContainerBorder }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_container_border', 'FFFFFF')}`}}
						/>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
						/>
						<Form.Field
							width='6'
							control={ Button }
							color='blue'
							icon='save'
							content='SAVE'
							onClick={ this.onSubmit }
							loading={ this.state.buttonUpdateLoading }
						/>
					</Form.Group>
				</Form>
				<br />
				<div style={{textAlign: 'center'}}>
					<div style={{width: '970px', border: '2px solid rgba(0,0,0,.25)', display: 'inline-block', margin: '5px'}}>
						<div className="bold" style={{borderBottom: '2px solid rgba(0,0,0,.25)'}}>Preview</div>
						<PreviewEmail
							width = {900}
							height = {600}
							content= {this.props.html}
						/>
					</div>
					{/* <div style={{width: '555px', border: '2px solid rgba(0,0,0,.25)', display: 'inline-block', margin: '0px'}}>
						<div className="bold" style={{borderBottom: '2px solid rgba(0,0,0,.25)'}}>Mobile</div>
						<PreviewEmail
							width = {500}
							height = {600}
							content = {this.props.html}
						/>
					</div> */}
				</div>
				<br />
				<br />
			</Tab.Pane>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.dashboardEmailsSettingsReducer.meta,
		html: state.dashboardEmailsSettingsReducer.html,
		isHtmlUpdated: state.dashboardEmailsSettingsReducer.isHtmlUpdated,
		templateConnection: state.dashboardEmailsSettingsReducer.templateConnection,
		sampleEmailRecipientEmail: state.dashboardEmailsSettingsReducer.sampleEmailRecipientEmail
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		renderAbandonedCartEmailTemplate (templateSettings) {
			dispatch( renderAbandonedCartEmailTemplate(templateSettings) );
		},

		updateTemplateConnectionById (id, templateConnection) {
			dispatch( updateTemplateConnectionById(id, templateConnection) );
		},

		getAbandonedCartTemplateConnection () {
			dispatch( getAbandonedCartTemplateConnection('abandoned_cart') );
		},

		updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) {
			dispatch( updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) );
		},

		updateFormField (templateConnection, fieldName, fieldValue) {
			dispatch( updateFormField(templateConnection, fieldName, fieldValue) );
		},

		resetAlertMessage () {
			dispatch( resetAlertMessage() );
		},

		reset() {
			dispatch( reset() );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(TemplateSettingsPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/customization-email-1-tab.js